'use strict';

/**
 * Creates new hashchange event callback
 * 
 * @param {Object} arg = {callback: callback_function, rule: {RegExp|String}, bubbling: {true|false}}  
 * @param {Object} hashControllerObj
 * @returns {null|hashCallBack}
 */
function hashCallBack(arg, hashControllerObj) {
    this.callback;
    this.bubbling = false;
    this.rule = null;
    this.hashObj = hashControllerObj;
    this.lock = false;
    var self = this;

    /**
     * Constructor
     * @param {Object} arg
     * @returns {hashCallBack|null}
     */
    this.init = function (arg) {
        if (this.setCallback(arg.callback)) {
            if (arg.bubbling) {
                this.bubbling = arg.bubbling;
            }
            this.setRule(arg.rule);
            window.addEventListener("hashchange", self.call, this.bubbling);
            return this;
        }
        return null;
    };

    /**
     * 
     * @param {Event} e
     * @returns {null|String} callback response | null
     */
    this.call = function (e) {
        if (self.checkRule(self.hashObj.get()) && !self.lock) {
            return self.callback(e, self);
        }
        return null;
    };

    /**
     * Check if event callback will be executed
     * @param {String} str hash string to test rule
     * @returns {Boolean}
     */
    this.checkRule = function (str) {
        return (!this.rule || this.rule.test(str));
    };

    /**
     * Set event callback execution rule.
     * @param {String|RegExp} rule
     */
    this.setRule = function (rule) {
        if (typeof (rule) !== 'undefined' && rule != '') {
            if (typeof (rule) !== 'object') {
                this.rule = new RegExp(rule);
            } else {
                this.rule = rule;
            }
        }
    };

    /**
     * 
     * @param {String|Function} callback
     * @returns {Boolean} Return true if callback is valid function, otherwise - false
     */
    this.setCallback = function (callback) {
        if (typeof (callback) === 'string') {
            if (typeof (window[callback]) === 'function') {
                this.callback = window[callback];
                return true;
            }
            return false;
        } else if (typeof (callback) === 'function') {
            this.callback = callback;
            return true;
        }
        return false;
    };

    return this.init(arg);
};

/**
 * hashChange event controller
 * @example register hashController.register({
 *			callback: (function(){} | "functioNname" | object.method),
 *			rule: (new RegExp("^[a-z]+$", "i") | "^[a-z]+$"),
 *			bubbling: false
 * });
 * @type hashController
 */
var hashController = new function () {

    this.db = new Array();
    var self = this;
    /**
     * 
     * @param {Object} callbackParams {
     *			callback: (function(){} | "functioNname" | object.method),
     *			rule: (new RegExp("^[a-z]+$", "i") | "^[a-z]+$"),
     *			bubbling: false
     * }
     * @returns {hashCallBack}
     */
    this.register = function (callbackParams) {
        var cb = new hashCallBack(callbackParams, this);
        self.db.push(cb);
        return cb;
    };

    /**
     * 
     * @returns {string} hash string without '#'
     */
    this.get = function () {
        return location.hash.replace(/^#/, '');
    };

    this.set = function (hash) {
        location.hash = hash;
    };

    this.clear = function () {
        //this.set(''); // deleted, because jumps to top page 
        history.replaceState({}, document.title, location.pathname);
    };

    this.replace = function (hash) {
        history.replaceState({}, document.title, location.pathname + '#' + hash);
    };

    this.trigger = function () {
        for (var i = 0; i < self.db.length; i++) {
            if (document.createEvent) {
                var e = document.createEvent("Event");
                e.initEvent("hashchange", true, true);//,window,0,0,0,0,0,false,false,false,false,0,null);
            } else {
                var e = new Event('hashchange', {});
            }
            self.db[i].call(e);
        }
    };

};

export {hashController};